export const resolveGetAttachmentUrl = (
  attachmentId = '',
  attachmentType?: string,
) => {
  switch (attachmentType) {
    case 'document':
      return `/person/documents/viewable-url/${attachmentId}`
    case 'enrollment':
      return `/enrollments/attachments/get-viewable-url/${attachmentId}`
    case 'email':
      return `/emails/get-viewable-url/${attachmentId}`
    case 'form':
      return `/v1/forms/attachment/get-viewable-url/${attachmentId}`
    default:
      return `/attachment/${attachmentId}`
  }
}

export const resolveUploadAttachmentUrl = (attachmentType?: string) => {
  switch (attachmentType ?? 'document') {
    case 'document':
      return '/person/documents/generate-presigned-url'
    case 'person-file':
      return '/persons/dataloader/generate-upload-url'
    case 'data-processing':
      return '/v1/data-processing/generate-life-line-upload-url'
    case 'enrollment':
      return '/enrollments/attachments/generate-presigned-url'
    case 'emails':
      return '/emails/generate-pre-signed-url'
    case 'emails-images':
      return '/emails/images/generate-pre-signed-url'
    default:
      return '/generate-presigned-url'
  }
}
